import Flex, { GAP_CLASS } from "components/Flex";
import { EyeIcon, PencilIcon } from "lucide-react";
import { bool, string } from "prop-types";

import classes from "./EditModeStatus.module.scss";

const EditModeStatus = ({
  editMode = false,
  target = "Section",
  viewPrefix = "You are viewing this",
  editPrefix,
}) => {
  const title = editMode
    ? editPrefix ?? `You are editing this${target ? ` ${target}` : ""}`
    : viewPrefix;
  const Icon = editMode ? PencilIcon : EyeIcon;

  return (
    <Flex className={classes["edit_mode_status"]} gap={GAP_CLASS.GAP_100}>
      <Icon data-testid="edit-mode-icon" size={14} />
      <span>{title}</span>
    </Flex>
  );
};

EditModeStatus.propTypes = {
  editMode: bool,
  target: string,
  viewPrefix: string,
  editPrefix: string,
};

export default EditModeStatus;
